








































import { routeInfos } from "@/router/routes";
import { Component, Vue } from "vue-property-decorator";
import LoginFormBoxComponent from "@/components/common/form/LoginFormBoxComponent.vue";
import InputComponent from "@/components/common/form/InputComponent.vue";
import SuccessBarComponent from "@/components/common/parts/SuccessBarComponent.vue";
import ErrorBarComponent from "@/components/common/parts/ErrorBarComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { postUserPasscodeApi } from "@/typescript/api_client/emesh_api/passwords/user_passcode_api";
import { PostUserPasscodeErrorResponse } from "@/typescript/api_client/emesh_api/passwords/types";
export { PostUserPasscodeErrorResponse };

@Component({
  components: {
    LoginFormBoxComponent,
    InputComponent,
    SuccessBarComponent,
    ErrorBarComponent,
    FooterComponent
  }
})
export default class PasswordsForgetPage extends Vue {
  routeInfos = routeInfos;
  inputValue: string = "";
  errorMsg: string = "";

  hideBar() {
    this.errorMsg = "";
  }

  onClickSend() {
    this.hideBar();
    postUserPasscodeApi(this.inputValue)
      .then(() => {
        this.$router.push("/passwords/issue");
      })
      .catch(() => {
        this.errorMsg = "The login_id or email address is incorrect";
      });
  }

  setValue(key: string, value: string) {
    this[key] = value;
  }
}
